import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const api = axios.create({ baseURL: '/api/v1/health-house', withCredentials: true });
api.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 401 && typeof window !== 'undefined') {
    clearAdminToken();
    window.location.href = '/web/admin-login';
  }
  return Promise.reject(error);
});

export const getHealthHouseMockConfig = async (stationId) => (await api.get(`/stations/${stationId}/mock-config`)).data;
export const updateHealthHouseMockConfig = async (stationId, payload) => (await api.put(`/stations/${stationId}/mock-config`, payload)).data;
export const resetHealthHouseMockConfig = async (stationId, payload) => (await api.post(`/stations/${stationId}/mock-config/reset`, payload)).data;
